"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiCorrectSubmission = exports.apiGetCorrectedSubmissions = exports.apiDeleteSubmission = exports.apiReadSubmissionCorrection = exports.apiUpdateSubmission = exports.apiCreateSubmission = exports.apiGetCourseSubmissionsToCorrect = exports.apiGetCourseSubmissions = exports.apiGetStudentSubmissions = exports.apiGetSubmissionAsTeacher = exports.apiGetSubmissionAsStudent = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
/**
 * Gets a submission based on the submissionId
 * Only allowed if the student owns the submission.
 * @param submissionId
 * @returns The submission.
 */
const apiGetSubmissionAsStudent = async (submissionId) => {
    const { data } = await client_1.default.get(`/submissions/get/student/${submissionId}`);
    return data;
};
exports.apiGetSubmissionAsStudent = apiGetSubmissionAsStudent;
/**
 * Gets a submission based on the submissionId
 * Only allowed if the teacher owns the student.
 * @param submissionId
 * @param studentId
 * @returns The submission.
 */
const apiGetSubmissionAsTeacher = async (submissionId, studentId) => {
    try {
        const { data } = await client_1.default.get(`/submissions/get/teacher/${studentId}/${submissionId}`);
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiGetSubmissionAsTeacher = apiGetSubmissionAsTeacher;
/**
 * Gets all submissions of the currently logged in student
 * @param after optional timestamp
 * @param excludeDeleted
 * @returns All submissions of this student.
 */
const apiGetStudentSubmissions = async (excludeDeleted = false, after) => {
    const { data } = await client_1.default.get('/submissions/get-student-submissions', {
        params: Object.assign({ excludeDeleted }, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiGetStudentSubmissions = apiGetStudentSubmissions;
/**
 * Gets all submissions of every student in the course.
 * @param courseId
 * @param excludeDeleted
 * @returns All submissions related to the course.
 */
const apiGetCourseSubmissions = async (courseId, excludeDeleted = false) => {
    const { data } = await client_1.default.get(`/submissions/get-course-submissions/${courseId}`, {
        params: { excludeDeleted },
    });
    return data;
};
exports.apiGetCourseSubmissions = apiGetCourseSubmissions;
/**
 * Gets all submissions of every student in the course that should get corrected.
 * @param courseId
 * @returns All submissions related to the course that should get corrected.
 */
const apiGetCourseSubmissionsToCorrect = async (courseId) => {
    try {
        const { data } = await client_1.default.get(`/submissions/get-course-submissions-to-correct/${courseId}`);
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiGetCourseSubmissionsToCorrect = apiGetCourseSubmissionsToCorrect;
/**
 * Creates a submission for the currently logged in student.
 * @param exerciseId
 * @param state
 * @param text
 * @returns The submission that was created.
 */
const apiCreateSubmission = async (exerciseId, exerciseChapter, exerciseTitle, exerciseHref, state, text) => {
    const { data } = await client_1.default.post('/submissions/create-submission', {
        exerciseId,
        exerciseChapter,
        exerciseTitle,
        exerciseHref,
        state,
        text,
    });
    return data;
};
exports.apiCreateSubmission = apiCreateSubmission;
/**
 * Updates a submission's state and/or text for the currently logged in student.
 * @param submissionId
 * @param state
 * @param text
 * @returns The updated submission.
 */
const apiUpdateSubmission = async (submissionId, state, text) => {
    const { data } = await client_1.default.put(`/submissions/update-submission/${submissionId}`, {
        id: submissionId,
        state,
        text,
    });
    return data;
};
exports.apiUpdateSubmission = apiUpdateSubmission;
/**
 * Sets the read field to true for a corrected submission.
 * @param submissionId
 * @returns The updated submission.
 */
const apiReadSubmissionCorrection = async (submissionId) => {
    const { data } = await client_1.default.post(`/submissions/read-submission-correction/${submissionId}`);
    return data;
};
exports.apiReadSubmissionCorrection = apiReadSubmissionCorrection;
/**
 * Deletes the submission if it belongs to the currently logged in student
 * @param submissionId
 */
const apiDeleteSubmission = async (submissionId) => {
    await client_1.default.delete(`/submissions/delete-submissions/${submissionId}`);
};
exports.apiDeleteSubmission = apiDeleteSubmission;
/**
 * Get all corrected submissions with the associated correction from the teacher
 * for the current student.
 */
const apiGetCorrectedSubmissions = async (excludeDeleted = false) => {
    try {
        const { data } = await client_1.default.get('/submissions/get-corrected-submissions', {
            params: { excludeDeleted },
        });
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiGetCorrectedSubmissions = apiGetCorrectedSubmissions;
/**
 * Creates a correction for a submission.
 * @param studentId
 * @param submissionId
 * @param text
 * @param annotatedText
 * @returns The created correction.
 */
const apiCorrectSubmission = async (studentId, submissionId, text, annotatedText) => {
    try {
        const { data } = await client_1.default.post(`/submissions/correction/correct-submission/${studentId}/${submissionId}`, {
            text,
            annotatedText,
        });
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiCorrectSubmission = apiCorrectSubmission;
//# sourceMappingURL=submissions.js.map